import { Config } from "@/shared/config";

const uri = Config.FraudDetectionServicebaseUri;
const pathToIdentity = "/frauddetectionservice/v1/identity";

export default {
  get fraudDetectionV1 () {
    return `${uri}/frauddetectionservice/v1`;
  },

  verify () {
    return uri + pathToIdentity + "/verify";
  },

  validateKbaQuiz () {
    return uri + pathToIdentity + "/validatekbaquiz";
  },

  validateKbaChallengeQuiz () {
    return uri + pathToIdentity + "/validatekbachallengequiz";
  },

  getFraudCheckList (): string {
    return `${this.fraudDetectionV1}/fraud-check-queue`;
  },
  getFraudCheckDetail (queueId: number): string {
    return `${this.fraudDetectionV1}/fraud-check-queue/${queueId}`;
  },
  setFraudCheckDetailAccepted (queueId: number): string {
    return `${this.fraudDetectionV1}/fraud-check-queue/${queueId}/accept`;
  },
  setFraudCheckDetailRejected (queueId: number): string {
    return `${this.fraudDetectionV1}/fraud-check-queue/${queueId}/reject`;
  },
  setFraudCheckAdjudicationStatus (): string {
    return `${this.fraudDetectionV1}/fraud-check-queue/adjudication-status`;
  },
  overrideUserData (queueId: number): string {
    return `${this.fraudDetectionV1}/fraud-check-queue/${queueId}/data-override`;
  },
  getFraudCheckLogs (queueId: number): string {
    return `${this.fraudDetectionV1}/fraud-check-queue/${queueId}/logs`;
  }
};